// Copyright (c) Docugami, Inc. All rights reserved.

import styled from 'styled-components';
import './Header.scss';

export interface DgUnauthenticatedShellProps {
    children?: JSX.Element | JSX.Element[];
}

const DgUnauthenticatedShellBody = styled.div`
    flex: 1;
    width: 100%;
    overflow: auto;
    display: flex;
    height: 100%;
    flex-wrap: wrap;
`;

export const DgUnauthenticatedShell = (props: DgUnauthenticatedShellProps): JSX.Element => {
    return (
        <div className="shellFullWindow">
            <DgUnauthenticatedShellBody>
                {props.children}
            </DgUnauthenticatedShellBody>
        </div>
    );
}
